module.exports = __webpack_public_path__ + "public/SiteIcons/mailLight.png?9101367b";